export default __webpack_public_path__ + "static/media/product-16.e6bc829d.jpg";